import './Home.css';
import cowonderLogo from '../../assets/cowonderlogo.png';
import { forwardRef } from 'react';
import { motion } from 'framer-motion';

const heroVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.18 } },
};

const heroItem = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: 'easeOut' } },
};

const Home = forwardRef<HTMLElement, { scrollToSection: (_: string) => void }>(({ scrollToSection }, ref) => {
  return (
    <section ref={ref} className="home">
      <div className="homeBanner">
        <motion.div
          className="flex flex-col items-center text-center px-6 max-w-4xl mx-auto"
          variants={heroVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.img
            variants={heroItem}
            src={cowonderLogo}
            alt="Cowonder Logo"
            className="w-[240px] md:w-[340px] lg:w-[400px] mb-8"
          />

          <motion.p
            variants={heroItem}
            className="text-white text-lg sm:text-xl md:text-2xl lg:text-3xl font-medium leading-relaxed max-w-2xl"
          >
            O sistema de gerenciamento e automação de processos para{' '}
            <span className="text-[--secondary-color] font-bold">sua empresa</span>
          </motion.p>

          <motion.div variants={heroItem} className="flex flex-col sm:flex-row gap-4 mt-10">
            <button
              className="bg-[--secondary-color] rounded-full text-white font-bold px-8 py-3.5 text-base hover:bg-[--secondary-color]/80 active:scale-95 transition-all duration-200 shadow-lg"
              onClick={() => scrollToSection('contact')}
            >
              Entre em contato
            </button>
            <button
              className="rounded-full text-white font-semibold px-8 py-3.5 text-base border border-white/40 hover:bg-white/10 active:scale-95 transition-all duration-200"
              onClick={() => scrollToSection('info')}
            >
              Saiba mais
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
});

export default Home;
